import { UIElementTypes } from '../ui-elements/element';
import { UIRectangle } from '../ui-elements/rectangle/rectangle';
import { UIText } from '../ui-elements/text/text';
import { UIButton } from '../ui-elements/button/button';
import { HitBoxTypes, UITriangle } from '../ui-elements/triangle/triangle';
import { guiCreatorDataStore } from '../stores/guiCreatorData';
import { UISlider } from '../ui-elements/slider/slider';
export const InputTypes = {
    INT: 'INT',
    FLOAT: 'FLOAT',
    BOOLEAN: 'BOOLEAN',
    STRING: 'STRING',
};
export function isStringColorString(value) {
    if (!value)
        return false;
    if (value.length != 7)
        return false;
    return !!value.match(/#[\da-f]+/);
}
export function isStringNumber(value) {
    return !isNaN(parseInt(value));
}
export function isPointInRectangle(x, y, p1, p2) {
    return p1.x <= x && x <= p2.x && p1.y <= y && y <= p2.y;
}
export function uiElementOf(uiElement) {
    switch (uiElement.uiElementType) {
        case UIElementTypes.RECT:
            const uiRectangle = uiElement;
            return new UIRectangle({
                x: parseInt('' + uiRectangle.x),
                y: parseInt('' + uiRectangle.y),
                z: parseInt('' + (uiRectangle.z || getNewZValue())),
                id: uiRectangle.id,
                width: parseInt('' + uiRectangle.width),
                height: parseInt('' + uiRectangle.height),
                name: uiRectangle.name,
                color: uiRectangle.color,
                group: uiRectangle.group,
            });
        case UIElementTypes.TEXT:
            const uiText = uiElement;
            return new UIText({
                x: parseInt('' + uiText.x),
                y: parseInt('' + uiText.y),
                z: parseInt('' + (uiText.z || getNewZValue())),
                id: uiText.id,
                width: uiText.width ? parseInt('' + uiText.width) : null,
                name: uiText.name,
                text: uiText.text,
                lineCount: parseInt('' + uiText.lineCount),
                fontSize: parseInt('' + uiText.fontSize),
                boxShowing: uiText.boxShowing,
                fitText: uiText.fitText,
                textAlignment: uiText.textAlignment,
                group: uiText.group,
            });
        case UIElementTypes.BUTTON:
            const uiButton = uiElement;
            return new UIButton({
                x: parseInt('' + uiButton.x),
                y: parseInt('' + uiButton.y),
                z: parseInt('' + (uiButton.z || getNewZValue())),
                id: uiButton.id,
                width: parseInt('' + uiButton.width),
                height: parseInt('' + uiButton.height),
                name: uiButton.name,
                backgroundColor: uiButton.backgroundColor,
                textColor: uiButton.textColor,
                text: uiButton.text,
                fontSize: parseInt('' + uiButton.fontSize),
                showHitBox: uiButton.showHitBox,
                hitBoxOffsetXLeft: uiButton.hitBoxOffsetXLeft ? parseInt('' + uiButton.hitBoxOffsetXLeft) : 0,
                hitBoxOffsetXRight: uiButton.hitBoxOffsetXRight ? parseInt('' + uiButton.hitBoxOffsetXRight) : 0,
                hitBoxOffsetYTop: uiButton.hitBoxOffsetYTop ? parseInt('' + uiButton.hitBoxOffsetYTop) : 0,
                hitBoxOffsetYBottom: uiButton.hitBoxOffsetYBottom ? parseInt('' + uiButton.hitBoxOffsetYBottom) : 0,
                vibrate: uiButton.vibrate || false,
                group: uiButton.group,
            });
        case UIElementTypes.TRIANGLE:
            const uiTriangle = uiElement;
            return new UITriangle({
                x: parseInt('' + uiTriangle.x),
                y: parseInt('' + uiTriangle.y),
                z: parseInt('' + (uiTriangle.z || getNewZValue())),
                name: uiTriangle.name,
                width: parseInt('' + uiTriangle.width),
                height: parseInt('' + uiTriangle.height),
                color: uiTriangle.color,
                rotation: parseInt('' + uiTriangle.rotation),
                id: uiTriangle.id,
                clickable: uiTriangle.clickable,
                hitBoxType: uiTriangle.hitBoxType || HitBoxTypes.RECTANGLE,
                points: uiTriangle.points,
                displayHitBox: uiTriangle.displayHitBox || false,
                hitBoxOffsetXLeft: uiTriangle.hitBoxOffsetXLeft || 0,
                hitBoxOffsetXRight: uiTriangle.hitBoxOffsetXRight || 0,
                hitBoxOffsetYTop: uiTriangle.hitBoxOffsetYTop || 0,
                hitBoxOffsetYBottom: uiTriangle.hitBoxOffsetYBottom || 0,
                vibrate: uiTriangle.vibrate || false,
                group: uiTriangle.group,
            });
        case UIElementTypes.SLIDER:
            const uiSlider = uiElement;
            return new UISlider({
                x: parseInt('' + uiSlider.x),
                y: parseInt('' + uiSlider.y),
                z: parseInt('' + (uiSlider.z || getNewZValue())),
                id: uiSlider.id,
                name: uiSlider.name,
                length: parseInt('' + uiSlider.length),
                vertical: uiSlider.vertical,
                group: uiSlider.group,
                sliderSize: uiSlider.sliderSize,
                sliderPosition: uiSlider.sliderPosition,
                sliderShowHitBox: uiSlider.sliderShowHitBox,
                sliderHitBoxOffset: uiSlider.sliderHitBoxOffset,
            });
    }
}
export function getNewZValue() {
    return guiCreatorDataStore.getAllElementsAsList()
        .reduce((highestZValue, uiElement) => uiElement.z > highestZValue ? uiElement.z : highestZValue, -1) + 1;
}
